import { orchestrator } from 'satcheljs';
import { shareFileSuggestion } from 'owa-search';
import { lazyCreateAttachmentFileFromExistingMailboxAttachment } from 'owa-attachment-well-data';
import { shareByEmail } from 'owa-attachment-sharebyemail';
import { ComposeTarget } from 'owa-mail-compose-store';
import { exitSearch } from 'owa-search';

export default orchestrator(shareFileSuggestion, async actionMessage => {
    const createAttachmentFileFromExistingMailboxAttachment = await lazyCreateAttachmentFileFromExistingMailboxAttachment.import();
    actionMessage.attachmentType.Size = 0; //Setting size as 0 to work around a check in getAttachmentInfo that does not apply in this case
    const attachmentFile = createAttachmentFileFromExistingMailboxAttachment(
        actionMessage.attachmentType
    );
    shareByEmail([attachmentFile], ComposeTarget.SecondaryTab);
    exitSearch('CommandExecuted', actionMessage.scenarioId);
});
